import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ChangeElementTypologyDialog,
  FormSubmitButtons,
  GridWrap,
  InfoWrapper,
  RHFSelect,
  RHFTagAutocomplete,
} from 'components';
import { tipologiaAppoggioOptions } from 'constants/selectOptions';
import { INFO } from 'pages/Inspections/config/info';
import { resetObjectSchedaIspezione } from 'utils/Inspections/L1/resetSchedaIspezione';
import useSchedaDifetti from 'utils/Inspections/L1/schedeDifetti';
import { isNullOrUndefinedOrEmptyString } from 'utils/utilities';

const AppoggiForm = ({
  appoggiFields,
  selected,
  setSelected,
  appoggiTable,
  selectedIdx,
}) => {
  const { getValues, setValue } = useFormContext({
    defaultValues: {
      appoggiTableValue: [],
      tipologiaAppoggioTableValue: '',
    },
  });

  const { populateSchedaDifetti } = useSchedaDifetti();

  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  useEffect(() => {
    setValue('appoggiTableValue', selected);
  }, [selected]);

  useEffect(() => {
    onResetAppoggi();
  }, [selectedIdx]);

  const changeAutocomplete = value => {
    setSelected(value);
  };

  const changeAppoggi = () => {
    const tipologiaAppoggioTableValue = getValues(
      'tipologiaAppoggioTableValue'
    );

    const ids = selected.map(el => el.codice);

    const appoggi = [...appoggiFields];

    appoggi.map((x, index) => {
      if (ids.includes(x?.codice)) {
        appoggi[index] = {
          ...x,
          tipologiaAppoggio: tipologiaAppoggioTableValue,
          ...(tipologiaAppoggioTableValue !== x.tipologiaAppoggio
            ? {
                ...resetObjectSchedaIspezione,
                schedaDifetti: populateSchedaDifetti(
                  'appoggio',
                  tipologiaAppoggioTableValue
                ).map(el => {
                  return {
                    ...el,
                    visto: false,
                    statoDifetto: '',
                    estensioneDifetto: '',
                    intensitaDifetto: '',
                    ps: false,
                    note: '',
                    media: [],
                  };
                }),
              }
            : null),
        };
      }
    });

    setValue(appoggiTable, appoggi);
    onResetAppoggi();
  };

  const onConfirmChangeAppoggi = () => {
    setOpenConfirmationDialog(false);
    changeAppoggi();
  };

  const onSubmitAppoggi = () => {
    const tipologiaAppoggioTableValue = getValues(
      'tipologiaAppoggioTableValue'
    );

    const ids = selected.map(el => el.codice);

    const appoggi = [...appoggiFields];

    const hasChangedTipologia = appoggi.some(el => {
      if (ids.includes(el?.codice)) {
        return (
          tipologiaAppoggioTableValue !== el.tipologiaAppoggio &&
          !isNullOrUndefinedOrEmptyString(el.tipologiaAppoggio)
        );
      }
    });

    if (hasChangedTipologia) {
      setOpenConfirmationDialog(true);
    } else {
      changeAppoggi();
    }
  };

  const onResetAppoggi = () => {
    setValue('appoggiTableValue', []);
    setValue('tipologiaAppoggioTableValue', '');
    setSelected([]);
  };

  return (
    <>
      <GridWrap container spacing={2} mt={2}>
        <InfoWrapper size={3} infoMessage={INFO.appoggiSelezionati.infoMessage}>
          <RHFTagAutocomplete
            multiple={true}
            id="tags-appoggi"
            name={'appoggiTableValue'}
            changeAutocomplete={value => {
              changeAutocomplete(value);
            }}
            labelName={'option.codice'}
            getOptionLabel={option => option.codice}
            opt={appoggiFields?.filter(
              el => !selected?.some(s => s?.id === el?.id)
            )}
            label="Appoggi selezionati"
          />
        </InfoWrapper>
        <GridWrap item xs={3}>
          <RHFSelect
            name="tipologiaAppoggioTableValue"
            label="Tipologia Appoggio"
            defaultValue={''}
            onChange={e => {
              setValue('tipologiaAppoggioTableValue', e.target.value);
            }}
            selectOptions={tipologiaAppoggioOptions}
          />
        </GridWrap>
        <GridWrap item xs={6}>
          <FormSubmitButtons
            onSubmit={onSubmitAppoggi}
            onReset={onResetAppoggi}
          />
        </GridWrap>
      </GridWrap>
      <ChangeElementTypologyDialog
        open={openConfirmationDialog}
        onClose={() => setOpenConfirmationDialog(false)}
        onConfirm={onConfirmChangeAppoggi}
      />
    </>
  );
};
AppoggiForm.propTypes = {
  appoggiFields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      codice: PropTypes.string,
      tipologiaAppoggio: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    })
  ),
  selected: PropTypes.array,
  setSelected: PropTypes.func,
  appoggiTable: PropTypes.string,
  selectedIdx: PropTypes.number,
};

export default AppoggiForm;
